import client from "./client";

export const acceptOfferPayee = (sessionId: string, clientId: string, iban?: string, ssn?: string, name?: string) =>
  client.post(
    `/client/${clientId}/session/${sessionId}/offer/accept/payee`,
    {
      iban,
      ssn,
      name,
    },
    {
      params: { enablePayeeJourney: true },
      headers: { session_id: sessionId },
    }
  );